module.exports = __webpack_public_path__ + "static/media/Alert.255a0c8d.svg";